/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.6.28",
    versionName: "0.2.0-nightly.2025.6.28",
    versionChannel: "nightly",
    buildDate: "2025-06-28T00:09:00.909Z",
    commitHash: "40537fd3bbb609802a1972e1c8e5b74c0ec1709c",
};
